import {
  formattedDate,
  getCookie,
  getSelectedAddons,
  getSelectedFees,
  addAddon,
  addFee,
  removeAddon,
  removeFee,
  preparePriceRequest,
  className
} from '@shared/functions'

window.addEventListener( 'DOMContentLoaded', () => {
  const datePickerBlock = document.querySelector(`.${className}`)
  if(datePickerBlock) {
    const addToCardBlock = document.querySelector('.wp-block-webdevia-rental-add-to-card')
    if ( !!addToCardBlock ) {
      const durationAndPrice = addToCardBlock.querySelector( '#durationAndPrice' )
    }
    const datePicker = datePickerBlock.querySelector(`.${className}__list__date-picker`)
    const timePicker = datePickerBlock.querySelector('.wd-time-picker')
    const timeSelects = timePicker?.querySelectorAll('select')
    const qty = document.querySelector('.wp-block-webdevia-rental-add-to-card__quantity input')

    const datesList = datePickerBlock.querySelector(`.${className}__list`)
    const globalDateTimeInputs = datesList.querySelector('li').innerHTML

    const messageBox = datePickerBlock.querySelector(`.${className}__message-box`)
    const options = JSON.parse( datePickerBlock.dataset?.options )
    const dateFormat = rentalDates.date_format ? rentalDates.date_format : 'Y-m-d'
  console.log(rentalDates)
    let dates = [], currentDate = {}, qtyVal = qty?.value, timesSet = false
    let settings = {
      minDate: "today",
      dateFormat: dateFormat,
      static: true,
      wrap: true,
      // enableTime: options?.enableTime,
      showMonths: options?.months,
      disable: [
        function(date) { 
          let exists = false
          if ( options.disabledDates.length ) {
            options.disabledDates.forEach( disabledDate => {
              if ( `${date.getFullYear()}-${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}` == disabledDate/* .slice(0, -9) */ ) {
                exists = true
              }
            } )
          }
          // @if type = 'pro'
          if ( options.disableWeekends && ( date.getDay() === 0 || date.getDay() === 6 ) ) {
            exists = true
          }
          // @endif
          return exists
        }
      ],
      locale: {
          weekdays: {
            longhand: [ 'Pazartesi','Salı','Çarşamba','Perşembe', 'Cuma','Cumartesi','Pazar'],
            shorthand: [ 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz']
          },
          months: {
          longhand: ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos', 'Eylül','Ekim','Kasım','Aralık'],
          shorthand: ['Oca','Şub','Mar','Nis','May','Haz','Tem','Ağu','Eyl','Eki','Kas','Ara']
          },
          today: 'Bugün',
          clear: 'Temizle'
        }
    }
  
    if( getCookie('rental_dates_cookie') ) {
      dates = JSON.parse(getCookie('rental_dates_cookie'))
    }
    

    if( options.range ) {
      settings.mode = 'range'
    }
    if ( options.hourly_pricing  ) {
      let dateTimeListItem
      settings.onClose = (  selectedDates, dateStr, instance  ) => {
        if ( selectedDates.length ) {
          if(options.range) {
            currentDate = {
              startDateTime: formattedDate( selectedDates[0], false ),
              endDateTime: formattedDate( selectedDates[1], false ),
              quantity: qtyVal
            }
          } else {
            currentDate = {
              startDateTime: formattedDate( selectedDates[0], false ),
              endDateTime: formattedDate( selectedDates[0], false ),
              quantity: qtyVal
            }
          }
          dateTimeListItem = instance._positionElement.closest(`.${className}__list__input`)
          dateTimeListItem.dataset.item_dates = JSON.stringify(currentDate)
          if ( dateTimeListItem.querySelector('.wd-time-picker') && !timesSet) {
            setTimePicker( dateTimeListItem )
          }
          if( timeSelects ) {
            timeSelects[0].querySelectorAll('option').forEach( option => {
              option.disabled = disableBeforeTime( new Date(), option ) && formattedDate( selectedDates[0], false ) === formattedDate( new Date(), false ) || disableTimes( option )
            })
          }
  
          let now = formattedDate( new Date(), false ),
              selected = formattedDate( selectedDates[0], false )
  
          if( new Date(now).getTime() - new Date(selected).getTime() > 0 ) {
            messageBox.innerHTML = `You can't select a date from the past`
            messageBox.style.display = 'block'
          } else {
            messageBox.innerHTML = ``
            messageBox.style.display = 'none'
            if (options.range) preparePriceRequest(options, qtyVal)
          }
        }
      }
    }
    if ( !options.hourly_pricing  ) {
      settings.onChange = (  selectedDates, dateStr, instance  ) => {
    
        if ( selectedDates.length ) {
          if( options.range ) {
            var range = new Date(selectedDates[1]).getTime() - new Date(selectedDates[0]).getTime()
            range = Math.round( range / 86400 + 1 )
            // @if type = 'pro'
            if( range < options.min_range ) {
              console.error(`Minimum range is ${options.min_range} Days`)
              messageBox.innerHTML = `Minimum range is ${options.min_range} Days`
              messageBox.style.display = 'block'
              instance.clear()
            } else {
              messageBox.innerHTML = ``
              messageBox.style.display = 'none'
            }
						// @endif
          } else {
            dates = {
              startDateTime: formattedDate( selectedDates[0], true ),
              endDateTime: formattedDate( selectedDates[0], true ),
              quantity: qtyVal
            }
            instance.closest(`.${className}__list__input`).dataset.item_dates = JSON.stringify(dates)
            if ( !!addToCardBlock ) {
              // priceAndDuration( options, dates, qtyVal )
              preparePriceRequest( options, qtyVal )
            }
          }
        }
        durationAndPrice.style.display = dateStr ? 'block' : 'none'
      }
      settings.onClose = (  selectedDates, dateStr, instance  ) => {
        
        if ( selectedDates.length >= 1 ) {
          let now = formattedDate( new Date(), false ),
              selected = formattedDate( selectedDates[0], false )
  
          if( new Date(now).getTime() - new Date(selected).getTime() > 0 ) {
            console.error(`You can't select dates from the past`)
            messageBox.innerHTML = `You can't select dates from the past`
            messageBox.style.display = 'block'
            durationAndPrice.style.display = 'none'
          } else {
            messageBox.innerHTML = ``
            messageBox.style.display = 'none'
            let d = {
              startDateTime: formattedDate( selectedDates[0], true ),
              endDateTime: formattedDate( undefined == selectedDates[1] ? selectedDates[0] : selectedDates[1], true ),
              quantity: qtyVal
            }
            if ( !!addToCardBlock ) {
              // if the start and end date are the same and the enable_overnight option is true, add 1 day to the end date  
              if( d.startDateTime == d.endDateTime && options.enable_overnight ) {
                d.endDateTime = new Date(new Date(d.endDateTime).getTime() + 24 * 60 * 60 * 1000).toISOString()
              }
              addToCardBlock.querySelector('input[name="dates"').value = JSON.stringify( d )
              datePickerBlock.querySelector(`.${className}__list__input`).dataset.item_dates = JSON.stringify( d )
              // priceAndDuration( options, d, qtyVal )
              preparePriceRequest( options, qtyVal )
            }
            dates = d
          }
        }
      }
    }
    flatpickr( datePicker, settings )
    
    if( dates.length ) {
      datesList.innerHTML = ''
      let inputs = globalDateTimeInputs
      dates.forEach( (date, i) => {
        inputs = i ? `<hr class="separator">${inputs}` : inputs
        let li = document.createElement('li')
        li.className = `${className}__list__input`
        li.dataset.item_dates = JSON.stringify({
          startDateTime: date.startDateTime,
          endDateTime: date.endDateTime,
          quantity: qtyVal
        })
        li.innerHTML = inputs
        if ( options.hourly_pricing  ) {
          setTimePicker ( li )
          const startHours = new Date(date.startDateTime).getHours() < 10 ? `0${new Date(date.startDateTime).getHours()}` : new Date(date.startDateTime).getHours(),
                startMinutes = new Date(date.startDateTime).getMinutes() < 10 ? `0${new Date(date.startDateTime).getMinutes()}` : new Date(date.startDateTime).getMinutes(),
                endHours = new Date(date.endDateTime).getHours() < 10 ? `0${new Date(date.endDateTime).getHours()}` : new Date(date.endDateTime).getHours(),
                endMinutes = new Date(date.endDateTime).getMinutes() < 10 ? `0${new Date(date.endDateTime).getMinutes()}` : new Date(date.endDateTime).getMinutes()
          
          li.querySelector('#startTimePicker').value = `${startHours}.${startMinutes}`
          li.querySelector('#endTimePicker').value = `${endHours}.${endMinutes}`
          
        }
        datesList.append(li)
        if( options.range ) {
          settings.defaultDate = [
            new Date( date.startDateTime ),
            new Date( date.endDateTime )
          ]
        } else {
          settings.defaultDate = [
            new Date( date.startDateTime )
          ]
        }
        flatpickr( li.querySelector(`.${className}__list__date-picker`), settings )
      } )
    }
    
    if( qty ) {
      qty.addEventListener( 'change', e => {
        qtyVal = e.target.value
      })
    }

    /******************* multiple dates *********************/
    const dateTimeInputsList = datePickerBlock.querySelector(`.${className}__list`)
    const controls = datePickerBlock.querySelectorAll(`.${className}__controls a`)
    const addDayBtn = controls[0]
    const removeDayBtn = controls[1]
    let datesCount = 1
    
    if( addDayBtn ) {
      addDayBtn.addEventListener( 'click', e => {
        if ( datesCount < 10 ) {
          let li = document.createElement('li')
          li.className = `${className}__list__input`
          li.innerHTML = globalDateTimeInputs
          li.dataset.item_dates = JSON.stringify({
            startDateTime: formattedDate(new Date(), true),
            endDateTime: formattedDate(new Date(), true),
            quantity: qtyVal
          })
          setTimePicker ( li )
          datesCount++
          removeDayBtn.style.display = datesCount == 1 ? 'none' : 'flex'
          dateTimeInputsList.append(li)
          flatpickr( dateTimeInputsList.querySelectorAll(`.${className}__list__date-picker`), settings )
        }
      } )
    }

    if( removeDayBtn ) {
      removeDayBtn.addEventListener( 'click', e => {
        if ( datesCount > 1 ) {
          datesCount--
          removeDayBtn.style.display = datesCount == 1 ? 'none' : 'flex'
          dates.pop()
          dateTimeInputsList.removeChild(dateTimeInputsList.lastChild)

          preparePriceRequest( options, qtyVal )
        }
      } )
    }
    // @if type = 'pro'
    //----------- Addons
    const addons = datePickerBlock.querySelector('.list-addons')
    if ( addons ) {
      const addonsInput = addToCardBlock.querySelector('input[name=wd_addons]')
      let addonsRequest = false
      addons.querySelectorAll('.list-addons__addon').forEach( addon => {
        const checkbox = addon.querySelector('input[type=checkbox]')
        const quantity = addon.querySelector('.qty')
        if( checkbox.checked ) {
          addAddon({
            id: checkbox.value,
            quantity: '1'
          })
          addonsRequest = true
        }
        checkbox.addEventListener( 'change', e => {
          if( e.target.checked && e.target.value ) {
           addAddon({
              id : e.target.value,
              quantity : quantity?.value
            })
          } else {
            removeAddon(e.target.value)
          }
          if( dates ) {
            addonsInput.value = JSON.stringify(getSelectedAddons())
            preparePriceRequest( options, qtyVal )
          } else {
            messageBox.innerHTML = `Please select a day first!`
            messageBox.style.display = 'block'
          }
        })
        quantity.addEventListener('input', e => {
          if( checkbox.checked ) {
            removeAddon(checkbox.value)
            addAddon({
              id: checkbox.value,
              quantity: e.target.value
            })
            if( dates ) {
              addonsInput.value = JSON.stringify(getSelectedAddons())
              preparePriceRequest( options, qtyVal )
            } else {
              messageBox.innerHTML = `Please select a day first!`
              messageBox.style.display = 'block'
            }
          }
        })
      })
      if( addonsRequest && dates.length ) {
        addonsInput.value = JSON.stringify(getSelectedAddons())
        preparePriceRequest( options, qtyVal )
      }
    } else {
      preparePriceRequest( options, qtyVal )
    }

    //----------- Additional Fees
    const fees = datePickerBlock.querySelector('.list-fees')
    if ( fees ) {
      const feesInput = addToCardBlock.querySelector('input[name=wd_fees]')
      let feesRequest = false
      fees.querySelectorAll('.list-fees__fee').forEach( fee => {
        const checkbox = fee.querySelector('input[type=checkbox]')
        if( checkbox.checked ) {
          addFee(checkbox.value)
          feesRequest = true
        }
        checkbox.addEventListener( 'change', e => {
          if( e.target.checked && e.target.value ) {
           addFee(e.target.value)
          } else {
            removeFee(e.target.value)
          }
          if( dates ) {
            feesInput.value = JSON.stringify(getSelectedFees())
            preparePriceRequest( options, qtyVal )
          } else {
            messageBox.innerHTML = `Please select a day first!`
            messageBox.style.display = 'block'
          }
        })
      })
      if( feesRequest && dates.length ) {
        feesInput.value = JSON.stringify(getSelectedFees())
        preparePriceRequest( options, qtyVal )
      }
    } else {
      preparePriceRequest( options, qtyVal )
    }
    // @endif
    function setTimePicker ( listItem ) {
      timesSet = true
      // populate time select control and disable hours before now
      const timeSelects = listItem?.querySelectorAll('.wd-time-picker select')
      let itemDates = JSON.parse(listItem.dataset.item_dates)
      
      if( typeof dates === 'string' ) {
        dates = JSON.parse(dates)
      }
      timeSelects.forEach( (select, i) => {
        if(select.closest(`.${className}__list__input`).dataset.item_dates) {
          populateTimePicker( select, itemDates, options.timePicker24Hour )
        }
        
        if (i % 2 !== 0) {
          timeSelects[i].querySelectorAll('option').forEach( option => {
            if( dates && !options.range ) { // Disable any Finish Time hours if the range option is off
              option.disabled = disableBeforeTime( new Date(), option ) && formattedDate( new Date(dates[0]), false ) === formattedDate( new Date(), false ) || disableTimes( option )
            }
          })
        }
      })
      let hours,
          startDateTime = new Date( itemDates.startDateTime ),
          endDateTime = new Date( itemDates.endDateTime )
      // enable the end time select and disable all times before start time
      if (timeSelects[0].onchange) {
        timeSelects.forEach( timeSelect => {
          timeSelect.removeEventListener('change', timeSelects.onchange)
        })
      }
      timeSelects[0].addEventListener( 'change', e => {
        if ( listItem.querySelector(`.${className}__list__date-picker input`).value ) {
          hours = e.target.value.split( '.' )
          itemDates = JSON.parse(listItem.dataset.item_dates)
          startDateTime = new Date( itemDates.startDateTime )
          endDateTime = new Date( itemDates.endDateTime )

          startDateTime.setHours( parseFloat( hours[0] ), parseFloat( hours[1] ) , 0 )
          if ( options._30MinutesIncrements ) {
            endDateTime.setHours( parseFloat( hours[0] ), parseFloat( hours[1] ) + 30, 0 )
          } else {
            endDateTime.setHours( parseFloat( hours[0] ) + 1, 0, 0 )
          }
          startDateTime.setHours( hours[0] )
          
          timeSelects[1].value = `${endDateTime.getHours() < 10 ? `0${endDateTime.getHours()}` : endDateTime.getHours()}.${endDateTime.getMinutes() < 10 ? `0${endDateTime.getMinutes()}` : endDateTime.getMinutes()}`
          
          timeSelects[1].querySelectorAll('option').forEach( option => {
            let optionTime = new Date(),
                firstDisableTimes = new Date(),
                lastDisableTimes = new Date(),
                startTime = new Date()

            hours = option.value.split( '.' )
            optionTime.setHours( hours[0], hours[1], 0 )
            if( dates ) {
              let selectedDisabledDates = []
              options.disabledDates.forEach( disabledDate => {
                if ( formattedDate( new Date ( disabledDate ), false ) == formattedDate( new Date ( dates[0] ), false ) ) {
                  selectedDisabledDates.push( new Date( disabledDate ) )
                }
              })
              if ( selectedDisabledDates.length ) {
                firstDisableTimes.setHours( selectedDisabledDates[0].getHours(), selectedDisabledDates[0].getMinutes(), 0)
                lastDisableTimes.setHours( selectedDisabledDates[selectedDisabledDates.length - 1].getHours(), selectedDisabledDates[selectedDisabledDates.length - 1].getMinutes(), 0)
                startTime.setHours( startDateTime.getHours(), startDateTime.getMinutes(), 0)
                if( firstDisableTimes.getTime() > startTime.getTime() ) {
                  option.disabled = disableBeforeTime( startDateTime, option ) || (optionTime.getTime() >= firstDisableTimes.getTime() )
                } else {
                  option.disabled = disableBeforeTime( startDateTime, option )
                }
              } else {
                if( !options.range) { // don't disable any Finish Time hours if the range option is on
                  option.disabled = disableBeforeTime( startDateTime, option )
                }
              }
            }
            if(isIntersecting(listItem)){
              messageBox.innerHTML = `Dates are overlapping!`
              messageBox.style.display = 'block'
              durationAndPrice.style.display = 'none'
            } else {
              messageBox.innerHTML = ``
              messageBox.style.display = 'none'
              timeSelects[1].disabled = false
            }
          })

        } else {
          e.target.selectedIndex = -1
          messageBox.innerHTML = `Please select a day first!`
          messageBox.style.display = 'block'
          durationAndPrice.style.display = 'none'
        }
      })

      timeSelects[1].addEventListener( 'change', e => {
        itemDates = JSON.parse(listItem.dataset.item_dates)
        
        startDateTime = new Date( itemDates.startDateTime )
        hours = timeSelects[0].value.split( '.' )
        startDateTime.setHours( parseFloat( hours[0] ) , parseFloat( hours[1] ), 0 )

        endDateTime = new Date( itemDates.endDateTime )
        hours = e.target.value.split( '.' )
        endDateTime.setHours( parseFloat( hours[0] ) , parseFloat( hours[1] ), 0 )

        e.target.closest(`.${className}__list__input`).dataset.item_dates = JSON.stringify({
          startDateTime: formattedDate(new Date(startDateTime), true),
          endDateTime: formattedDate(new Date(endDateTime), true),
          quantity: qtyVal
        })
        
        if( isIntersecting(listItem) ) {
          messageBox.innerHTML = `Dates are overlapping!`
          messageBox.style.display = 'block'
          durationAndPrice.style.display = 'none'
        } else {
          messageBox.innerHTML = ``
          messageBox.style.display = 'none'
          if(!!addToCardBlock) {
            addToCardBlock.querySelector('input[name="dates"]').value = JSON.stringify( dates )
          }

          preparePriceRequest( options, qtyVal )
        }
      })
    }

    function disableBeforeTime ( startDate, option ) {
      let optHour = option.value.split('.')[0],
          optMinute = option.value.split('.')[1],
          optDate = new Date(), startDateHours = new Date()
      optDate.setHours( optHour, optMinute, 0 )
      startDateHours.setHours( startDate.getHours(), startDate.getMinutes(), 0 )
      if ( optDate.getTime() <= startDateHours.getTime() ) {
        return true
      }
      return false
    }

    function disableTimes ( option ) {
      const item = option.closest(`.${className}__list__input`)
      const date = new Date( item.querySelector(`input`).value )
      let optHour = parseFloat( option.value.split('.')[0] ) < 10 ? `0${parseFloat( option.value.split('.')[0] )}` : parseFloat( option.value.split('.')[0] ),
          optMinute = parseFloat( option.value.split('.')[1] ) < 10 ? `0${parseFloat( option.value.split('.')[1] )}` : parseFloat( option.value.split('.')[1] ),
          month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1,
          day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate(),
          flag = false
      options.disabledDates.forEach( disabledDate => {
        if ( `${date.getFullYear()}-${month}-${day} ${optHour}:${optMinute}:00` == disabledDate ) {
          flag = true
        }
      })
      return flag
    }

    function populateTimePicker(startTimePicker, selectedDate, timePicker24Hour) {
      let open = 0,
          close = 24
      
      startTimePicker.innerHTML = ''
      selectedDate = new Date(selectedDate.startDateTime)
      // @if type = 'pro'
      if( options.working_hours_enable && selectedDate ) {
        JSON.parse( options.working_hours.replace( /[\\]/g, '' ) ).forEach( day => {
          switch ( day.working_day ) {
            case 'weekdays':
              if( [ 1, 2, 3, 4, 5 ].includes( selectedDate.getDay() ) ) {
                open = parseInt( day.working_day_start.split( ':' )[0] )
                close = parseInt( day.working_day_end.split( ':' )[0] )
              }
              break
            case 'weekends':
              if( [ 0, 6 ].includes( selectedDate.getDay() ) ) {
                open = parseInt( day.working_day_start.split( ':' )[0] )
                close = parseInt( day.working_day_end.split( ':' )[0] )
              }
              break
            case 'mon':
              if( getDayName(selectedDate).toLowerCase() == day.working_day.toLowerCase() ) {
                open = parseInt( day.working_day_start.split( ':' )[0] )
                close = parseInt( day.working_day_end.split( ':' )[0] )
              }
              break
            case 'tue':
              if( getDayName(selectedDate).toLowerCase() == day.working_day.toLowerCase() ) {
                open = parseInt( day.working_day_start.split( ':' )[0] )
                close = parseInt( day.working_day_end.split( ':' )[0] )
              }
              break
            case 'wed':
              if( getDayName(selectedDate).toLowerCase() == day.working_day.toLowerCase() ) {
                open = parseInt( day.working_day_start.split( ':' )[0] )
                close = parseInt( day.working_day_end.split( ':' )[0] )
              }
              break
            case 'thu':
              if( getDayName(selectedDate).toLowerCase() == day.working_day.toLowerCase() ) {
                open = parseInt( day.working_day_start.split( ':' )[0] )
                close = parseInt( day.working_day_end.split( ':' )[0] )
              }
              break
            case 'fri':
              if( getDayName(selectedDate).toLowerCase() == day.working_day.toLowerCase() ) {
                open = parseInt( day.working_day_start.split( ':' )[0] )
                close = parseInt( day.working_day_end.split( ':' )[0] )
              }
              break
            case 'sat':
              if( getDayName(selectedDate).toLowerCase() == day.working_day.toLowerCase() ) {
                open = parseInt( day.working_day_start.split( ':' )[0] )
                close = parseInt( day.working_day_end.split( ':' )[0] )
              }
              break
            case 'sun':
              if( getDayName(selectedDate).toLowerCase() == day.working_day.toLowerCase() ) {
                open = parseInt( day.working_day_start.split( ':' )[0] )
                close = parseInt( day.working_day_end.split( ':' )[0] )
              }
              break
            default:
                open = parseInt( day.working_day_start.split( ':' )[0] )
                close = parseInt( day.working_day_end.split( ':' )[0] )
              break
          }
        } )
      }
      // @endif
  
      for( let i = open; i <= close; i++ ) {
        let opt = document.createElement('option')
        if( i === 24) {
          opt.value = '00.00'
        }
        else if( i.toString().length === 1 ) {
          opt.value = '0' + i +'.00'
          opt.text = '0' + i + ( timePicker24Hour ? ':00' : ':00 AM')
        } else {
          if ( timePicker24Hour ) {
            opt.value = i + '.00'
            if( i < 12 ) {
                opt.text = i + ':00'
            }
            else {
              opt.text = i + ':00'
            }
          } else {
            opt.value = i + '.00'
            if( i < 12 ) {
              opt.text = i + ':00 AM'
            }
            else {
              opt.text = ( i === 12 ? 12 : ( i - 12 ) ) + ':00 PM'
            }
          }
        }    
        startTimePicker.appendChild(opt)
  
        // 30 min increments (optional)
        if( options._30MinutesIncrements && i < close ) {
          let opt30 = document.createElement('option')
          opt30.value = opt.value.split('.')[0]+'.30'
          opt30.text = opt.text.split(':')[0] + ':30 ' + opt.text.split(':')[1].split(' ')[1]
          startTimePicker.appendChild(opt30)
        }
      }
    }

    function getDayName( date ) {
      return date.toLocaleDateString('en-US', { weekday: 'short' });        
    }
  
    function isIntersecting(listItem){
      const list = listItem.closest(`.${className}__list`).querySelectorAll('li')
      let intersecting = false
      list.forEach( (Item, i) => {
        if( i < list.length - 1 ) {
          let itemDates = JSON.parse( Item.dataset.item_dates )
          let nextItemDates = JSON.parse( list[i+1].dataset.item_dates )
          let startA = new Date( itemDates.startDateTime ),
              endA = new Date( itemDates.endDateTime ),
              startB = new Date( nextItemDates.startDateTime ),
              endB = new Date( nextItemDates.endDateTime )
          
          if ( startA !== startB && endA !== endB && startA.toISOString().substring(0,10) === startB.toISOString().substring(0,10) && startA.getTime() <= endB.getTime() && endA.getTime() >= startB.getTime() ) {
            intersecting = true
          }
        }
      })
      return intersecting
    }
  
  }

} )